import { A2kStack } from "./A2kStack.js";
window.customElements.define("a2k-stack", A2kStack);
